export default __webpack_public_path__ + "fe4d1017dc589c4f5b049e60d99b694f.svg";